import { readable } from "svelte/store";

export const colours = readable({
    primaryBlue: "#223f71",
    secondaryBlue: "#091F45",
    orange: "#f15922",
    green: "#1f6453",
    red: "#992129",
    cyan: '#00bcd4',
    text: "#444444",
});
